/** Tiroir tactile : la rubrique de la page en cours est la seule ouverte à l'arrivée. */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import type { MenuItem } from './sidebarConfig';

export function useOpenCurrentSection(
  touch: boolean,
  items: MenuItem[],
  setOpenSections: (titles: string[]) => void,
) {
  const { pathname } = useLocation();
  useEffect(() => {
    if (!touch) return;
    const current = items.find(
      (item) =>
        item.children?.some((child) => child.url === pathname) ||
        item.sections?.some((section) => section.children.some((child) => child.url === pathname)),
    );
    if (current) setOpenSections([current.title]);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- à l'ouverture et au changement de page seulement
  }, [touch, pathname]);
}
